module.exports = __webpack_public_path__ + "static/media/opensans-bolditalic-webfont.495dfe5e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-bolditalic-webfont.woff
// module id = 1026
// module chunks = 0